import React from 'react'
import { Box } from '@mui/material'
import SummaryStatCard from './SummaryStatCard'

// MF-526 — Reusable responsive container: lays out a set of KPI cards (4 → 2 → 1 columns). It only
// knows "render these stat blocks in a grid", so it's the reusable canvas the bento chart bank
// (step 2) will build on — you feed it a different set of blocks per role / per layout.
const SummaryGrid = ({ stats = [] }) => {
  if (!stats.length) return null
  return (
    <Box
      sx={{
        display: 'grid',
        gap: 2,
        gridTemplateColumns: {
          xs: '1fr',
          sm: 'repeat(2, minmax(0, 1fr))',
          lg: 'repeat(4, minmax(0, 1fr))'
        }
      }}
    >
      {stats.map((stat, i) => (
        <SummaryStatCard key={stat.key || stat.label || i} stat={stat} />
      ))}
    </Box>
  )
}

export default SummaryGrid
